import React from "react";
import { HeaderBar } from "@sonder/ui/source/styled/fragments/HeaderBar";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";
import { Filters } from "tasks/components/Filters";
import { Groups } from "tasks/components/Groups";

export const TasksHeader = () => (
  <Scroller>
    <ScrollerContent>
      <HeaderBar>
        <Filters />
        <Groups />
      </HeaderBar>
    </ScrollerContent>
  </Scroller>
);
